import { render, staticRenderFns } from "./WifiError.vue?vue&type=template&id=89bb46ae&scoped=true"
import script from "./WifiError.vue?vue&type=script&lang=js"
export * from "./WifiError.vue?vue&type=script&lang=js"
import style0 from "./WifiError.vue?vue&type=style&index=0&id=89bb46ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89bb46ae",
  null
  
)

export default component.exports